export const AbiTypeToDefaultValue = {
  uint8: 0,
  uint16: 0,
  uint24: 0,
  uint32: 0,
  uint40: 0,
  uint48: 0,
  uint56: 0n,
  uint64: 0n,
  uint72: 0n,
  uint80: 0n,
  uint88: 0n,
  uint96: 0n,
  uint104: 0n,
  uint112: 0n,
  uint120: 0n,
  uint128: 0n,
  uint136: 0n,
  uint144: 0n,
  uint152: 0n,
  uint160: 0n,
  uint168: 0n,
  uint176: 0n,
  uint184: 0n,
  uint192: 0n,
  uint200: 0n,
  uint208: 0n,
  uint216: 0n,
  uint224: 0n,
  uint232: 0n,
  uint240: 0n,
  uint248: 0n,
  uint256: 0n,

  int8: 0,
  int16: 0,
  int24: 0,
  int32: 0,
  int40: 0,
  int48: 0,
  int56: 0n,
  int64: 0n,
  int72: 0n,
  int80: 0n,
  int88: 0n,
  int96: 0n,
  int104: 0n,
  int112: 0n,
  int120: 0n,
  int128: 0n,
  int136: 0n,
  int144: 0n,
  int152: 0n,
  int160: 0n,
  int168: 0n,
  int176: 0n,
  int184: 0n,
  int192: 0n,
  int200: 0n,
  int208: 0n,
  int216: 0n,
  int224: 0n,
  int232: 0n,
  int240: 0n,
  int248: 0n,
  int256: 0n,

  bytes1: "0x00",
  bytes2: "0x0000",
  bytes3: "0x000000",
  bytes4: "0x00000000",
  bytes5: "0x0000000000",
  bytes6: "0x000000000000",
  bytes7: "0x00000000000000",
  bytes8: "0x0000000000000000",
  bytes9: "0x000000000000000000",
  bytes10: "0x00000000000000000000",
  bytes11: "0x0000000000000000000000",
  bytes12: "0x000000000000000000000000",
  bytes13: "0x00000000000000000000000000",
  bytes14: "0x0000000000000000000000000000",
  bytes15: "0x000000000000000000000000000000",
  bytes16: "0x00000000000000000000000000000000",
  bytes17: "0x0000000000000000000000000000000000",
  bytes18: "0x000000000000000000000000000000000000",
  bytes19: "0x00000000000000000000000000000000000000",
  bytes20: "0x0000000000000000000000000000000000000000",
  bytes21: "0x000000000000000000000000000000000000000000",
  bytes22: "0x00000000000000000000000000000000000000000000",
  bytes23: "0x0000000000000000000000000000000000000000000000",
  bytes24: "0x000000000000000000000000000000000000000000000000",
  bytes25: "0x00000000000000000000000000000000000000000000000000",
  bytes26: "0x0000000000000000000000000000000000000000000000000000",
  bytes27: "0x000000000000000000000000000000000000000000000000000000",
  bytes28: "0x00000000000000000000000000000000000000000000000000000000",
  bytes29: "0x0000000000000000000000000000000000000000000000000000000000",
  bytes30: "0x000000000000000000000000000000000000000000000000000000000000",
  bytes31: "0x00000000000000000000000000000000000000000000000000000000000000",
  bytes32: "0x0000000000000000000000000000000000000000000000000000000000000000",

  bool: false,
  address: "0x0000000000000000000000000000000000000000",

  "uint8[]": [] as number[],
  "uint16[]": [] as number[],
  "uint24[]": [] as number[],
  "uint32[]": [] as number[],
  "uint40[]": [] as number[],
  "uint48[]": [] as number[],
  "uint56[]": [] as bigint[],
  "uint64[]": [] as bigint[],
  "uint72[]": [] as bigint[],
  "uint80[]": [] as bigint[],
  "uint88[]": [] as bigint[],
  "uint96[]": [] as bigint[],
  "uint104[]": [] as bigint[],
  "uint112[]": [] as bigint[],
  "uint120[]": [] as bigint[],
  "uint128[]": [] as bigint[],
  "uint136[]": [] as bigint[],
  "uint144[]": [] as bigint[],
  "uint152[]": [] as bigint[],
  "uint160[]": [] as bigint[],
  "uint168[]": [] as bigint[],
  "uint176[]": [] as bigint[],
  "uint184[]": [] as bigint[],
  "uint192[]": [] as bigint[],
  "uint200[]": [] as bigint[],
  "uint208[]": [] as bigint[],
  "uint216[]": [] as bigint[],
  "uint224[]": [] as bigint[],
  "uint232[]": [] as bigint[],
  "uint240[]": [] as bigint[],
  "uint248[]": [] as bigint[],
  "uint256[]": [] as bigint[],

  "int8[]": [] as number[],
  "int16[]": [] as number[],
  "int24[]": [] as number[],
  "int32[]": [] as number[],
  "int40[]": [] as number[],
  "int48[]": [] as number[],
  "int56[]": [] as bigint[],
  "int64[]": [] as bigint[],
  "int72[]": [] as bigint[],
  "int80[]": [] as bigint[],
  "int88[]": [] as bigint[],
  "int96[]": [] as bigint[],
  "int104[]": [] as bigint[],
  "int112[]": [] as bigint[],
  "int120[]": [] as bigint[],
  "int128[]": [] as bigint[],
  "int136[]": [] as bigint[],
  "int144[]": [] as bigint[],
  "int152[]": [] as bigint[],
  "int160[]": [] as bigint[],
  "int168[]": [] as bigint[],
  "int176[]": [] as bigint[],
  "int184[]": [] as bigint[],
  "int192[]": [] as bigint[],
  "int200[]": [] as bigint[],
  "int208[]": [] as bigint[],
  "int216[]": [] as bigint[],
  "int224[]": [] as bigint[],
  "int232[]": [] as bigint[],
  "int240[]": [] as bigint[],
  "int248[]": [] as bigint[],
  "int256[]": [] as bigint[],

  "bytes1[]": [] as `0x${string}`[],
  "bytes2[]": [] as `0x${string}`[],
  "bytes3[]": [] as `0x${string}`[],
  "bytes4[]": [] as `0x${string}`[],
  "bytes5[]": [] as `0x${string}`[],
  "bytes6[]": [] as `0x${string}`[],
  "bytes7[]": [] as `0x${string}`[],
  "bytes8[]": [] as `0x${string}`[],
  "bytes9[]": [] as `0x${string}`[],
  "bytes10[]": [] as `0x${string}`[],
  "bytes11[]": [] as `0x${string}`[],
  "bytes12[]": [] as `0x${string}`[],
  "bytes13[]": [] as `0x${string}`[],
  "bytes14[]": [] as `0x${string}`[],
  "bytes15[]": [] as `0x${string}`[],
  "bytes16[]": [] as `0x${string}`[],
  "bytes17[]": [] as `0x${string}`[],
  "bytes18[]": [] as `0x${string}`[],
  "bytes19[]": [] as `0x${string}`[],
  "bytes20[]": [] as `0x${string}`[],
  "bytes21[]": [] as `0x${string}`[],
  "bytes22[]": [] as `0x${string}`[],
  "bytes23[]": [] as `0x${string}`[],
  "bytes24[]": [] as `0x${string}`[],
  "bytes25[]": [] as `0x${string}`[],
  "bytes26[]": [] as `0x${string}`[],
  "bytes27[]": [] as `0x${string}`[],
  "bytes28[]": [] as `0x${string}`[],
  "bytes29[]": [] as `0x${string}`[],
  "bytes30[]": [] as `0x${string}`[],
  "bytes31[]": [] as `0x${string}`[],
  "bytes32[]": [] as `0x${string}`[],

  "bool[]": [] as boolean[],
  "address[]": [] as `0x${string}`[],

  bytes: "0x",
  string: "",
} as const;
